import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolClientAction } from '@cbridge-packages/symbol-client';
import { InfinityDataGridAction } from '@cbridge-modules/infinity-data-grid';

export const reloadSymbolClientListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolClientAction.reload,
    SymbolClientAction.create.done,
    SymbolClientAction.update.done,
    SymbolClientAction.remove.done,
    SymbolClientAction.bulkRemove.done,
  ),
  mergeMap(() => {
    return [
      InfinityDataGridAction.refreshData(),
    ];
  }),
);
